import 'intersection-observer'; //polyfill for Intersection Observer API, https://www.npmjs.com/package/intersection-observer

let mode = {
    SINGLE: 'single',
    INTERVAL: 'interval',
    CONTINUOUS: 'continuous'
};

const buildThreshold = (start = 0.5, end = 1, steps = 100) => {
    const threshold = Array.from(
        { length: steps },
        (x, i) => start + (i / steps) * (end - start)
    );

    // Returns an array like [start, ...n, end]
    return [...threshold, end];
};

function getMaxIntersectionRatio(entry) {
    const elBound = entry.boundingClientRect;
    return Math.min(entry.rootBounds.height / elBound.height, 1);
}

function trigger(el, type) {
    const e = document.createEvent('HTMLEvents');
    e.initEvent(type, true, true);
    el.dispatchEvent(e);
}

export default function(threshold = buildThreshold(0.4, 1, 25)) {
    return {
        install(Vue) {
            Vue.prototype.$intersectionObserver = new IntersectionObserver(
                (entries, observer) => {
                    entries.forEach(entry => {
                        const el = entry.target;
                        const isVisible =
                            entry.intersectionRatio >=
                            getMaxIntersectionRatio(entry) *
                                el.__targetIntersectionRatio;

                        trigger(el, isVisible ? 'visible' : 'invisible');

                        if (isVisible && !el.__isVisible) {
                            if (el.__mode === mode.SINGLE) {
                                observer.unobserve(el);
                                trigger(el, 'changeToVisible');
                            } else if (el.__mode === mode.INTERVAL) {
                                observer.unobserve(el);
                                trigger(el, 'changeToVisible');
                                el.__timeout = setTimeout(() => {
                                    observer.observe(el);
                                }, el.__cooldownMilliSecond);
                            } else if (el.__mode === mode.CONTINUOUS) {
                                // Do nothing
                            }
                        }

                        el.__isVisible = isVisible;
                    });
                },
                {
                    threshold
                }
            );
        }
    };
}

export const intersectDirective = {
    bind(el, binding) {
        el.__mode = binding.value.mode || mode.SINGLE;
        el.__targetIntersectionRatio =
            binding.value.targetIntersectionRatio || 0.5;
        el.__cooldownMilliSecond =
            binding.value.cooldownMilliSecond || 60 * 1000;
        el.__timeout = undefined;
        el.__inVisible = false;
    },
    inserted(el, binding, vnode) {
        vnode.context.$intersectionObserver.observe(el);
    },
    unbind(el, binding, vnode) {
        if (el.__timeout) clearTimeout(el.__timeout);
        vnode.context.$intersectionObserver.unobserve(el);
        delete el.__mode;
        delete el.__targetIntersectionRatio;
        delete el.__cooldownMilliSecond;
        delete el.__timeout;
        delete el.__inVisible;
    }
};
